// extracted by mini-css-extract-plugin
export default {"GameResult":"GameResult_GameResult__5xMjm","IsViewingStream":"GameResult_IsViewingStream__qERdc"};